import settings from "./settings";
export default {
    "msgChangePrice": "レシート情報を変更した場合、合計金額・賞品選択状態がリセットされます。よろしいですか？",
    "msgRemoveReceipt": "レシートを削除した場合、合計金額・賞品選択状態がリセットされます。よろしいですか？",
    "msgAppendReceipt": "レシートを追加した場合、合計金額・賞品選択状態がリセットされます。よろしいですか？",
    "msgPriceLowerAlert": `レシート情報を入力後、計算するボタンを押してください。
レシート${settings.priceLabel}合算金額が${settings.minApplyPrice.toLocaleString()}円以上の場合のみ賞品を選択することができます。`
}
